import { render, staticRenderFns } from "./EocSidebarFolderCrudItem.vue?vue&type=template&id=17daa196&scoped=true&"
import script from "./EocSidebarFolderCrudItem.vue?vue&type=script&lang=js&"
export * from "./EocSidebarFolderCrudItem.vue?vue&type=script&lang=js&"
import style0 from "./EocSidebarFolderCrudItem.vue?vue&type=style&index=0&id=17daa196&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17daa196",
  null
  
)

export default component.exports